<template>
    <modal-custom-black modalId="modalVerifyEmailLogin" :hideTopCloseButton="true">

        <div class="modal-verify-email-login-wrapper">
            <div class="modal-verify-email-login-header">
                {{ translate.login.modalVerifyEmail.header }}
            </div>

            <div class="modal-verify-email-login-body mt-4">
                <p>
                    {{ translate.login.modalVerifyEmail.body1 }} <span>{{ emailToDisplay }}</span>{{ translate.login.modalVerifyEmail.body2 }}
                </p>
                <p> {{ translate.login.modalVerifyEmail.body3 }}</p>
                <p> {{ translate.login.modalVerifyEmail.body4 }}</p>

                <div class="modal-verify-email-login-email-form">
                    <span class="modal-verify-email-login-email-form-show-form" v-if="!showEmailForm" @click="showForm">
                        {{ translate.login.modalVerifyEmail.usedWrongEmail }}
                    </span>
                    <span class="modal-verify-email-login-email-form-resend" @click="resendVerificationEmail" v-if="!showEmailForm">
                        {{ translate.login.modalVerifyEmail.resendEmail }}
                        <span class="spinner-border spinner-border-sm ml-2" v-if="emailLoading"></span>
                    </span>

                    <template v-if="showEmailForm">
                        <span class="error-input-container" :class="{'has-error':emailTakenError}">
                            <input type="email" class="form-control" v-model="newEmail">
                        </span>

                        <error-component :message="translate.login.emailWrongFormat"
                                         v-if="!newEmailInValidFormat && newEmail"></error-component>

                        <error-component :message="translate.login.emailTaken"
                                         v-if="emailTakenError"></error-component>

                        <button-with-loading class="btn btn-secondary mt-3 w-100"
                                             @click.native="changeEmailSubmit"
                                             :disabled="!newEmailInValidFormat || emailLoading"
                                             :text="translate.login.modalVerifyEmail.buttonChangeEmail"
                                             :loading="emailLoading"
                        ></button-with-loading>

                    </template>

                    <div v-if="emailSuccess" class="modal-verify-email-login-success-msg">
                        {{ translate.login.modalVerifyEmail.emailSuccessfullySent }}
                    </div>

                </div>
            </div>
        </div>

    </modal-custom-black>
</template>

<script>

import ModalCustomBlackComponent from "@/components/partials/ModalCustomBlackComponent";
import ButtonWithLoadingComponent from "@/components/global/ButtonWithLoadingComponent";

const data = () => ({
    showEmailForm: false,
    newEmail: '',
    emailLoading: false,
    emailSuccess: false,
    emailTakenError: false,
    emailToDisplay: '',
    basicEmailRegex: '.+\\@.+\\..+',
});

function created() {
    this.emailToDisplay = this.userEmail;
}

function resetVariables() {
    this.emailSuccess = false;
    this.emailTakenError = false;
}

function showForm() {
    this.resetVariables();
    this.showEmailForm = true;
}

async function resendVerificationEmail() {
    if (this.emailLoading) {
        return;
    }

    this.resetVariables();
    this.emailLoading = true;

    const [err, response] = await to(
        api.user.resendVerificationEmail(this.userHash)
    )

    this.emailLoading = false;

    if (err) {
        return toastr.error(this.translate.home.errorCommon);
    }

    this.emailSuccess = true;
}

async function changeEmailSubmit() {
    if (this.emailLoading) {
        return;
    }

    this.resetVariables();
    this.emailLoading = true;

    const payload = {
        userIdHash: this.userHash,
        email: this.newEmail
    }

    const [err, response] = await to(
        api.user.changeEmail(payload)
    )

    this.emailLoading = false;

    if (err) {
        const errors = _.get(err, "response.data.errors", {});

        if (_.get(errors, 'email.0') === "The email has already been taken.") {
            this.emailTakenError = true;
        }

        return;
    }

    this.emailToDisplay = this.newEmail;
    this.showEmailForm = false;
    this.emailSuccess = true;
}

export default {
    data,
    created,
    computed: {
        ...mapState([
            'translate'
        ]),
        newEmailInValidFormat() {
            if (!this.newEmail || !this.newEmail.length) {
                return false;
            }

            return !!this.newEmail.match(this.basicEmailRegex);
        }
    },
    methods: {
        resendVerificationEmail,
        changeEmailSubmit,
        resetVariables,
        showForm,
    },
    props: ['userHash', 'userEmail'],
    components: {
        'button-with-loading': ButtonWithLoadingComponent,
        'modal-custom-black': ModalCustomBlackComponent
    }
};
</script>
